import React, { useContext } from 'react';
import { getEnvironment } from '@src/env.config';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Link } from '@uhg-abyss/web/ui/Link';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { Button } from '@uhg-abyss/web/ui/Button';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useLazyGetReportsQuery } from '@src/store/services/cdb/onlineServices';
import { useLazyGetGPSReportsQuery } from '@src/store/services/gps/onlineServices';
import { FileContext } from '@src/routes/Routes';
import { cellValueHighLight } from '@src/utils/tableUtils';
import { Table } from '@src/common/Table';
import { maskUsingUserAccess } from '@src/utils';
import { useAuth } from '@src/Providers/AuthProvider';
import CryptoJS from 'crypto-js';
import { encdata } from '@src/constants';
import { Card } from '@uhg-abyss/web/ui/Card';
export const TermSubmitted = ({ fileId, isChild, setId }) => {
  // const { data: termSubmittedList } = useGettermssubmittedQuery(fileId);

  const { user } = useAuth();
  const router = useRouter();
  const { service } = router.getRouteParams();
  const { fileData } = useContext(FileContext);

  const columns = React.useMemo(() => {
    return [
      {
        Header: 'File Processing Date',
        accessor: service === 'gps' ? 'fileProcessingDate' : 'processingDt',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 100,
        width: 100,
        Cell: ({ row, value }) => {
          const processedValue = value.split(' ')[0];

          return cellValueHighLight({
            value: processedValue,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Severity',
        accessor: 'severityCode',
        canToggleVisibilty: false,
        isHiddenByDefault: false,
        minWidth: 80,
        width: 80,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Employee ID',
        accessor: 'subscrId',
        canToggleVisibilty: false,
        isHiddenByDefault: service === 'gps' ? true : false,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Medicare ID',
        accessor: 'medicareId',
        canToggleVisibilty: false,
        isHiddenByDefault: service === 'gps' ? false : true,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Family ID',
        accessor: 'familyId',
        canToggleVisibilty: false,
        isHiddenByDefault: service === 'gps' ? false : true,
      },
      {
        Header: 'Name',
        accessor: 'name',
        canToggleVisibilty: false,
        isHiddenByDefault: false,
        minWidth: 110,
        width: 110,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Rel',
        accessor: service === 'gps' ? 'mbrTicRelCd' : 'relationship',
        canToggleVisibilty: true,
        isHiddenByDefault: service === 'gps' ? true : false,
        minWidth: 50,
        width: 50,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Status',
        accessor: service === 'gps' ? 'status' : 'stsTxt',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 100,
        width: 100,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Type',
        accessor: 'type',
        minWidth: 150,
        width: 150,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Transaction Source',
        accessor: 'transactionSource',
        minWidth: 65,
        width: 65,
        canToggleVisibilty: true,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
        isHiddenByDefault: service === 'gps' ? true : false,
      },

      {
        Header: 'Warning name',
        accessor: 'warningName',
        minWidth: 75,
        width: 75,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Data field',
        accessor: 'dataField',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        minWidth: 95,
        width: 95,
        Cell: ({ row, value }) => {
          return cellValueHighLight({
            value,
            fileData,
            typeValue: row?.original?.multiTransId,
          });
        },
      },
      {
        Header: 'Customer data',
        accessor: service === 'gps' ? 'customerData' : 'custData',
        minWidth: 100,
        width: 100,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ row, value }) => {
          const maskedValue = maskUsingUserAccess(
            value,
            row?.original?.dataField || '',
            user?.maskingType || 0
          );

          const typeValue = row?.original?.multiTransId;
          return cellValueHighLight({
            value: maskedValue,
            fileData,
            typeValue,
          });
        },
      },
      {
        Header: 'Source Data',
        accessor: 'sourceData',
        minWidth: 100,
        width: 100,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ row, value }) => {
          const maskedValue = maskUsingUserAccess(
            value,
            row?.original?.dataField || '',
            user?.maskingType || 0
          );

          const typeValue = row?.original?.multiTransId;
          return cellValueHighLight({
            value: maskedValue,
            fileData,
            typeValue,
          });
        },
      },
      {
        Header: 'Coverage Type',
        accessor: 'covType',
        minWidth: 100,
        width: 100,
        canToggleVisibilty: true,
        isHiddenByDefault: service === 'gps' ? true : false,
        Cell: ({ row, value }) => {
          const typeValue = row?.original?.multiTransId;
          return cellValueHighLight({ value, fileData, typeValue });
        },
      },
      {
        Header: 'Plan variation code',
        accessor: 'planVariation',
        minWidth: 110,
        width: 110,
        canToggleVisibilty: true,
        isHiddenByDefault: service === 'gps' ? true : false,
        Cell: ({ row, value }) => {
          const typeValue = row?.original?.multiTransId;
          return cellValueHighLight({ value, fileData, typeValue });
        },
      },
      {
        Header: 'Reporting Code',
        accessor: 'reportingCode',
        canToggleVisibilty: true,
        isHiddenByDefault: service === 'gps' ? true : false,
        minWidth: 90,
        width: 90,
        Cell: ({ row, value }) => {
          const typeValue = row?.original?.multiTransId;
          return cellValueHighLight({ value, fileData, typeValue });
        },
      },
      {
        Header: 'Coverage Start Date',
        accessor: 'coverageStartDate',
        canToggleVisibilty: true,
        isHiddenByDefault: service === 'gps' ? true : false,
        minWidth: 110,
        width: 110,
        Cell: ({ row, value }) => {
          const typeValue = row?.original?.multiTransId;
          return cellValueHighLight({ value, fileData, typeValue });
        },
      },
      {
        Header: 'Coverage End Date',
        accessor: 'coverageEndDate',
        canToggleVisibilty: true,
        isHiddenByDefault: service === 'gps' ? true : false,
        minWidth: 110,
        width: 110,
        Cell: ({ row, value }) => {
          const typeValue = row?.original?.multiTransId;
          return cellValueHighLight({ value, fileData, typeValue });
        },
      },

      {
        Header: 'Detail View',
        accessor: 'detailView',
        enableSorting: false,
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        label: 'Customer Name',
        width: 80,
        minWidth: 80,
        Cell: ({ row }) => {
          const nameSplit = row?.original?.name.split(',');
          const firstName = nameSplit[1].trim();
          const lastName = nameSplit[0].trim();
          const typeValue = row?.original?.multiTransId?.trim();
          const value =
            service !== 'gps' &&
            fileData?.multilevelSubmitter &&
            typeValue?.length > 0
              ? 'View'
              : 'Detail View';

          const link =
            service === 'gps'
              ? `/home/gps-detail-view/`
              : fileData?.multilevelSubmitter && typeValue?.length > 0
              ? `/home/multi-level-view/`
              : `/home/detail-view/`;

          const linkData = {
            fileID: fileData?.fileID || fileData.fileId,
            transSetId: fileData?.transSetId,
            medicareId: row?.original?.medicareId,
            firstName: firstName,
            lastName: lastName.trim(),
            processingDt: fileData?.processingDt,
            customerName: fileData?.customerName,
            mbrTicRelCd: row?.original?.mbrTicRelCd,
            transId: row?.original?.transId,
            subscrId: row?.original?.subscrId,
            sbmtGrpName: fileData?.sbmtGrpName,
            relationship: row?.original?.relationship,
            cescustnbr: fileData?.cescustnbr,
            sbmtGrpId: fileData?.sbmtGrpId,
            reportType: 'TRM',
            empId: row?.original?.employeeId,
          };

          const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(linkData),
            encdata
          ).toString();

          const newUrl = `${link}${encodeURIComponent(encryptedData)}`;

          return cellValueHighLight({
            value: (
              <Flex
                css={{
                  gap: '10px',
                }}
              >
                <Link
                  size="$sm"
                  target="_blank"
                  href={newUrl}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(newUrl, 'DetailViewTab');
                  }}
                >
                  <Button
                    variant="outline"
                    size="$sm"
                    css={{
                      fontSize: '12px',
                    }}
                  >
                    <strong>{value}</strong>
                  </Button>
                </Link>
              </Flex>
            ),
            fileData,
            typeValue,
          });
        },
      },
    ];
  }, [user]);

  return (
    <Card
      css={{
        'abyss-card-root': { width: '100%', padding: '0', borderRadius: '4px' },
      }}
    >
      <div
        style={{
          backgroundColor:
            'var(--abyss-colors-web-semantic-color-surface-container-primary)',
          color:
            'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
          fontSize: '18px',
          padding: '24px',
          borderTopLeftRadius: '3px',
          borderTopRightRadius: '3px',
          fontWeight: 'bold',
        }}
      >
        Term Submittted / Auto cancel Transactions
      </div>
      <div style={{ padding: '16px' }}>
        <Table
          columns={columns}
          dataKey="fileListTable"
          fetch={
            service === 'gps'
              ? useLazyGetGPSReportsQuery
              : useLazyGetReportsQuery
          }
          requestParams={{
            ...router.getRouteParams(),
            ...fileData,
          }}
          customHeaderSection={
            fileData?.allDate && fileData?.allDate === 'true' ? (
              <SelectInput
                label="File Processing Date"
                value=""
                onChange={(value) => {}}
                width="288px"
                options={[{ label: '----', value: '' }]}
              />
            ) : null
          }
          showGlobalFilter={true}
          downloadMenuItems={[
            {
              title: 'Download CSV',
              onClick: 'exportVisibleData',
              csvFilename: `term-submitted-${service}.csv`,
            },
          ]}
        />
      </div>
    </Card>
  );
};
